<script setup lang="ts">
import { RouterView } from 'vue-router'
import ErrorBoundary from '@uiKit/components/ErrorBoundary.vue'
import ToastHost from '@uiKit/components/ToastHost.vue'
</script>

<template>
  <ErrorBoundary>
    <RouterView />
  </ErrorBoundary>

  <!-- Mounted at the root so toasts survive layout switches and route changes. -->
  <ToastHost />
</template>
